import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-atheletics-sports',
  templateUrl: './atheletics-sports.component.html',
  styleUrls: ['./atheletics-sports.component.scss']
})
export class AtheleticsSportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
